// import { VueMaskDirective } from 'v-mask'

import BoxImage from 'components/common/BoxImage'
import SvgIcon from 'components/SvgIcon'
// import SwipeToCloseDialog from 'components/common/SwipeToCloseDialog'
import Alert from 'components/common/Alert'
import InnerLoadingSpinner from 'components/InnerLoadingSpinner'
import LoadMoreSpinner from 'components/LoadMoreSpinner'
import EmptyComponent from 'components/EmptyComponent'
import FtxDialog from 'components/common/dialog/ftx-dialog'
import ProfileLink from 'components/common/profile-link'
import UserAvatar from 'components/UserAvatar'
import QCurrencyInput from 'components/common/QCurrencyInput'
// import PasswordInput from 'components/common/PasswordInput'
import RouterLinkNull from 'components/common/router-link-null'
import AuthLink from 'components/common/AuthLink'

export default async ({ app }) => {
  app.component('BoxImage', BoxImage)
  app.component('SvgIcon', SvgIcon)
  // app.component('SwipeToCloseDialog', SwipeToCloseDialog)
  app.component('Alert', Alert)
  app.component('InnerLoadingSpinner', InnerLoadingSpinner)
  app.component('LoadMoreSpinner', LoadMoreSpinner)
  app.component('EmptyComponent', EmptyComponent)
  app.component('FtxDialog', FtxDialog)
  app.component('ProfileLink', ProfileLink)
  app.component('UserAvatar', UserAvatar)
  // app.directive('mask', VueMaskDirective)
  app.component('QCurrencyInput', QCurrencyInput)
  // app.component('PasswordInput', PasswordInput)
  app.component('RouterLinkNull', RouterLinkNull)
  app.component('AuthLink', AuthLink)
}
